import frustumCull from '../frustumCull'
import hsv_rgb from '../hsv_rgb'
import noise3D from '../noise3D'

export default `${noise3D + hsv_rgb}
  uniform vec3 uColor1;
  uniform vec3 uColor2;
  uniform vec3 uColor3;
  uniform vec3 uBgColor;
  uniform vec4 uProgress;
  uniform vec4 uRectData;

  varying vec3 vPosition;
  varying vec3 vNormal;

  void main(){
    vec3 no = abs(vNormal);
    // Find which component is largest and create one-hot vector
    float maxComponent = max(no.x, max(no.y, no.z));
    no = vec3(equal(no, vec3(maxComponent)));

    vec2 f = vec2(0.0, 0.9);
    vec3 i = smoothstep(f.x, f.y, abs(vPosition));
    i = 1.0 - pow(i, vec3(2.0));

    vec3 innerShadow = 1.0 - vec3(
      pow(i.y * i.z, 2.0),
      pow(i.x * i.z, 2.0),
      pow(i.x * i.y, 2.0)
    );

    vec4 color = vec4(vec3(0.0), 1.0);
    color.rgb = mix(uBgColor, vec3(0.5), innerShadow.x * innerShadow.y * innerShadow.z);

    vec2 rainbowFactor = vec2(
      snoise(vec3(vPosition * 0.5 + vec3(0.0, uProgress.y * 1.0, 0.0))),
      snoise(vec3(vPosition * 0.5 + vec3(5.2) - vec3(0.0, uProgress.y, 0.0)))
    ) * 0.5 + 0.5;


    vec3 rainbowColor = uColor1;
    vec3 hsv = rgb2hsv(rainbowColor);
    hsv.r -= rainbowFactor.x * 0.25;
    hsv.b += rainbowFactor.y * 0.2;

    rainbowColor = hsv2rgb(hsv);
    color.rgb = mix(color.rgb, rainbowColor, no.g);


    #ifndef IS_GLASS_RENDER
    ${frustumCull}
    #endif
    
    gl_FragColor = color;
    gl_FragColor.rgb = mix(uBgColor, gl_FragColor.rgb, uProgress.x);
  }
`
